module.exports = __webpack_public_path__ + "img/fleerun-smc.0b88c5ad.png";